import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';
import seekerRoutes from './seekerRoutes';
import providerRoutes from './providerRoutes';
import sharedRoutes from './sharedRoutes';
import segmentPageviews from './guards/segmentPageviews';
import siftPageviews from './guards/siftPageviews';
import { sitterOnboardingBeforeEach } from './guards/sitterOnboardingGuards';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [...seekerRoutes, ...providerRoutes, ...sharedRoutes] as RouteConfig[],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // Scroll to saved position
    }
    return { x: 0, y: 0 }; // Scroll to the top
  },
});

// WARNING
// If you add beforeEach or afterEach guards, the code will be executed on every page
// You may want to use beforeEnter instead.
// Be careful and write tests~~~

// Restore server-side headers when leaving onboarding routes (only for provider route navigation)
router.beforeEach(sitterOnboardingBeforeEach);

router.afterEach(siftPageviews);
router.afterEach(segmentPageviews);

export default router;
